import { useState, useEffect } from 'react';
import styles from './list.module.css';
import axios from 'axios';
import Loader from '../../components/Loader';
import { authData } from "../../components/getAuth";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";

const AssignPopup = ({ modalClose, onSubmit, selectedRows }) => {
  const auth = authData();
  const API_TOKEN = auth?.api_token;
  const [loading, setLoading] = useState(false);
  const [driverList, setDriverList] = useState([]);

  const { register, handleSubmit, control, formState: { errors } } = useForm({
    mode: 'onChange'
  });

  useEffect(() => {
    axios.get(process.env.REACT_APP_API_URL + 'v1/p-driver-dd-list', {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      }
    }).then(response => {
      if (response.data.status === 'SUCCESS') {
        setDriverList(response.data.data);
      }
    });
  }, [API_TOKEN]);

  const onSubmitLocal = (data) => {
    modalClose();
    setLoading(true);
    data = { ...data, status: -1 };

    let postData = { driver_id: data?.driver?.value, bookingIds: selectedRows }

    axios.post(process.env.REACT_APP_API_URL + 'v1/assign-bookings', postData, {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      }
    }).then(response => {
      if (response.data.status === 'SUCCESS') {
        onSubmit(response.data.message);
      } else {
        setLoading(false);
      }
    }).catch(error => {
      setLoading(false);
    });
  }


  return (<>
    {loading && <Loader />}
    <div className={`${styles.FullDiv}`}>
      <form onSubmit={handleSubmit(onSubmitLocal)}>
        <div className={`${styles.FormGroupFull}`}>
          <label className={`${styles.FormLabel}`}>Select Driver*</label>
          <Controller
            control={control}
            options={driverList}
            {...register('driver', { required: 'Please select driver' })}
            render={({ field }) => (
              <Select {...field} options={driverList} />
            )}
          />
          {errors.driver && <span className={`${styles.ErrorM}`}>{errors.driver.message}</span>}
        </div>
        <div className={`${styles.FormButtonArea}`}>
          <input className={`${styles.CancelBU}`} value="Cancel" type="button" onClick={modalClose.bind(this)} />
          <input className={`${styles.SubmitBU}`} value="Assign" type="submit" />
        </div>
      </form>
    </div>
  </>)
}

export default AssignPopup;